"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabWrapperStyles = exports.tabTransformWrapper = exports.closeIcon = exports.tabMainWrapper = exports.tabStylesDark = exports.tabStyles = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var padding = {
  small: '16px 10px',
  medium: '16px 16px 20px',
  large: '20px 16px 24px'
};
var paddingDark = {
  small: '8px 10px',
  medium: '12px 12px 18px',
  large: '16px 12px 20px'
};

var tabStyles = function tabStyles(theme, active, disabled, index, size, vertical) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-block;padding:", padding[size] || '16px 16px 20px', ";", !vertical &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin-bottom:-1px;"), "\n  cursor:pointer;font-size:", _styleConsts.font.size[size] || '14px', ";transition:background-color 0.25s;outline:none;", !index && index !== 0 &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-bottom:2px solid transparent;"), "\n  ", active &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", vertical ? theme.color.accent : theme.color.text, ";border-color:", theme.color.accent, ";font-weight:", vertical ? '600' : _styleConsts.font.weight.bold, ";&:hover{border-color:", theme.color.accent, ";}"), "\n  ", disabled ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("opacity:", theme.disabledOpacity, ";outline:0;cursor:not-allowed;&:hover{border-bottom:none;}") :
    /*#__PURE__*/
    (0, _reactEmotion.css)("&:hover{color:", vertical ? theme.color.accent : theme.color.black1, ";}"), "\n  ", vertical &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-bottom:none;"))
  );
};

exports.tabStyles = tabStyles;

var tabStylesDark = function tabStylesDark(theme, active, disabled, index, size, vertical, isMobile) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-block;", !vertical &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin-bottom:0px;"), "\n  color:", theme.color.dark.iron, ";font-weight:bold;min-width:fit-content;text-transform:uppercase;letter-spacing:2px;margin-right:32px;position:relative;::after{content:'';position:absolute;left:50%;bottom:0px;width:0px;height:2px;background:#fff;-webkit-transform:translate3D(-50%,0,0);-ms-transform:translate3D(-50%,0,0);transform:translate3D(-50%,0,0);-webkit-transition:0.2s all ease-out;transition:0.2s all ease-out;}", isMobile &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin-right:12px;"), ";", !vertical &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("height:auto;display:flex;align-items:center;padding:0 0 12px 0px;", isMobile &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin-right:12px;padding:0 0 8px 0px;"), ";"), ";line-height:normal;&:hover{border-color:", active ? theme.color.dark.amethyst : theme.color.dark.iron, ";", !vertical && active &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("::after{width:100%;background:", theme.color.dark.amethyst, ";}"), ";", !vertical && !active &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("::after{width:100%;background:", theme.color.dark.iron, ";}"), ";}", active &&
    /*#__PURE__*/
    (0, _reactEmotion.css)(!vertical &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("::after{width:100%;background:", theme.color.dark.amethyst, ";}"), ";color:", theme.color.dark.amethyst, ";"), "\n  cursor:pointer;font-size:", _styleConsts.font.size[size] || '14px', ";transition:background-color 0.25s;outline:none;", disabled &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("opacity:", theme.color.dark.disabledOpacity, ";outline:0;cursor:not-allowed;&:hover{border-bottom:none;}"), "\n  ", vertical &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-bottom:none;padding:", paddingDark[size] || '12px 12px 18px', ";"))
  );
};

exports.tabStylesDark = tabStylesDark;
var tabMainWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("position:relative;");
exports.tabMainWrapper = tabMainWrapper;
var closeIcon =
/*#__PURE__*/
(0, _reactEmotion.css)("margin-top:-4px;cursor:pointer;");
exports.closeIcon = closeIcon;

var tabTransformWrapper = function tabTransformWrapper(theme, vertical, isDarkTheme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("transform:translate3d(0px,0px,0px);transition:transform 0.3s cubic-bezier(0.645,0.045,0.355,1),width 0.3s cubic-bezier(0.645,0.045,0.355,1),-webkit-transform 0.3s cubic-bezier(0.645,0.045,0.355,1);z-index:1;position:absolute;", vertical ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("left:0;width:2px;top:0px;") :
    /*#__PURE__*/
    (0, _reactEmotion.css)("left:0;height:2px;bottom:0px;"), "\n\n  -webkit-box-sizing:border-box;box-sizing:border-box;background-color:", isDarkTheme ? theme.color.dark.amethyst : theme.color.accent, ";-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0;z-index:0;border-radius:14px;")
  );
};

exports.tabTransformWrapper = tabTransformWrapper;

var tabWrapperStyles = function tabWrapperStyles(theme, vertical, isDarkTheme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;", isDarkTheme &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("overflow:scroll;width:100%;&::-webkit-scrollbar{width:0px;background:transparent;height:0px;}"), "\n  ", vertical ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("height:100%;border-left:1px solid ", theme.color.grey2, ";flex-direction:column;") : !isDarkTheme &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-bottom:1px solid ", theme.color.grey2, ";"))
  );
};

exports.tabWrapperStyles = tabWrapperStyles;